import React from 'react'
import '../Brochure/scss/Brochure.css'
import { Image } from 'cloudinary-react'


const Brochure = () => {
  return (
    <div className='Brochuremain'>
    <iframe allowfullscreen="allowfullscreen"  className="fp-iframe" src="https://heyzine.com/flip-book/aeb4828a59.html"
     style={{border:' 1px solid lightgray', width:' 100%', height: '100vh'}}></iframe>

<div style={{position: 'fixed', bottom: '2rem', right: '2rem', zIndex: '999', backgroundImage: 'none', background: 'none', boxSizing: 'none', borderStyle: 'none',cursor:'pointer'}}>
                <a href="https://api.whatsapp.com/send?phone=9321714104&text=I%20am%20interested!" target="_blank">
                    <Image style={{height: '7vh', width: '7vh',cursor:'pointer',}} publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1680763106/whatsapp_gqgneb.png" cloudName="dxluokypg" />
                </a>
            </div>
    </div>
  )
}

export default Brochure



